module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "head-top"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "header-link"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://thzwb.thnet.gov.cn/yytx/#/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.loginClick
    }
  }, [_vm._v(_vm._s(_vm.isLogin ? ("欢迎你，" + _vm.userName) : '登录'))]), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.loginClick
    }
  }, [_vm._v("注册")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/help/index.html"
    }
  }, [_vm._v("帮助中心")]), _vm._v(" "), _c('span', {
    on: {
      "mouseover": function($event) {
        return _vm.wxqrshow(true)
      },
      "mouseout": function($event) {
        return _vm.wxqrshow(false)
      }
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("微信公众号")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isWxqrshow),
      expression: "isWxqrshow"
    }],
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-thzfw.png")
    }
  })])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTelToastshow),
      expression: "isTelToastshow"
    }],
    staticClass: "zxdh-toast"
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-3.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("020-37690333")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "toolbar-collapse collapse in",
    attrs: {
      "id": "collapseToolbar"
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "toolbar-item",
    on: {
      "click": function($event) {
        return _vm.telToastshow(true)
      },
      "mouseout": function($event) {
        return _vm.telToastshow(false)
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _vm._m(10)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.thnet.gov.cn/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/logo-zf.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "footerTop"
  }, [_c('div', {
    staticClass: "foottop-left"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('b', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("【 联系我们 】")]), _vm._v(" "), _c('div', [_vm._v("联系电话： ")]), _vm._v(" "), _c('div', [_vm._v("政务大厅服务热线：020-37690333 ")]), _vm._v(" "), _c('div', [_vm._v("公安户政业务专线：020-37690245 ")]), _vm._v(" "), _c('div', [_vm._v("出入境（外国人）专线：12345 ")])]), _vm._v(" "), _c('div', {
    staticClass: "part partmiddle"
  }, [_c('b', {
    staticStyle: {
      "color": "#000"
    }
  }), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('b', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("【 建议反馈 】")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.thnet.gov.cn/zwfw/thzw/gtc/lyxd/index.html"
    }
  }, [_vm._v(" 留言选登 ")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://tyrz.gd.gov.cn/pscp/sso/static/?client_id=gzzffwrx&client_secret=0sYDtapNbbM0&redirect_uri=http%3A%2F%2Fgz12345.gz.gov.cn%2Fgdzwfw%2FverificationReturn.do%3Fref%3D%2F&response_type=code&scope=all&service=initService"
    }
  }, [_vm._v(" 建议投诉")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://tyrz.gd.gov.cn/pscp/sso/static/?client_id=gzzffwrx&client_secret=0sYDtapNbbM0&redirect_uri=http%3A%2F%2Fgz12345.gz.gov.cn%2Fgdzwfw%2FverificationReturn.do%3Fref%3D%2F&response_type=code&scope=all&service=initService"
    }
  }, [_vm._v(" 投诉查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "foottop-right"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('b', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("【 移动办事二维码 】")]), _vm._v(" "), _c('div', {
    staticClass: "ewm"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-yss.png")
    }
  }), _c('div', [_vm._v("粤省事")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-hhb.png")
    }
  }), _c('div', [_vm._v("穗好办")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-thzfw.png")
    }
  }), _c('div', [_vm._v("天河政府网")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBottom"
  }, [_c('div', {
    staticClass: "l-img"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4401060050"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-jc.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://bszs.conac.cn/sitename?method=show&id=3600B4435AA97EB4E053012819ACCA26"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-dz.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "r-span"
  }, [_c('span', [_vm._v("主办：广州市天河区人民政府")]), _vm._v(" "), _c('span', [_vm._v("承办：广州市天河区政务服务和数据管理局")]), _vm._v(" "), _c('span', [_vm._v("备案序号：粤ICP备15016469号-2")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../static/img/global/footer-gh.png")
    }
  }), _vm._v("粤公网安备44010602000147号")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/znkf/index.html?region=440106"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("智能咨询")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://thzwb.thnet.gov.cn/terminal/web/terminal/static/busiPage/xiaowu/validphone.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-2.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("政务云窗")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toolbar-link"
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-3.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("电话咨询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://apps.gdzwfw.gov.cn/zwfwyy/index.html#/?region=440106"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-4.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("办事预约")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/progress-query"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-5.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("进度查询")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "http://thzwb.thnet.gov.cn/PreGuid/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-6.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("申报指引")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "target": "_blank",
      "href": "https://my.gz.gov.cn/portal-citizen/home"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-7.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("市民网页")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-item toolbar-top"
  }, [_c('a', {
    staticClass: "toolbar-link",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/global/toolbar-top.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("返回顶部")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a84abbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1125
// module chunks = 0